package com.shadowings.gero.presentation.component.quiz

import androidx.compose.runtime.saveable.Saver
import androidx.compose.runtime.saveable.listSaver

/**
 * Saver for List<String>. Converts any List implementation (including SubList)
 * into a standard ArrayList, which is 100% compatible with Android Bundle and SaveableStateRegistry.
 */
val StringListSaver: Saver<List<String>, Any> = listSaver(
    save = { it.toList() },
    restore = { it }
)

/**
 * Saver for List<Int> (used by WordSelection, WordSpelling, etc.).
 */
val IntListSaver: Saver<List<Int>, Any> = listSaver(
    save = { it.toList() },
    restore = { it }
)
